export default __webpack_public_path__ + "static/media/image-glass-and-keyboard.c2b923ac.jpg";